import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
import { computed, defineComponent, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { SingleCategoryEvent } from "@/test/scenarios/booking";
import BookingModule from "@/store/modules/booking";
import { Currencies } from "@/constants/currency";
import { deleteUncompletedBookingAccountings, applyPayment, createRefundPSSAccounting } from "@/utils/vue-helpers/accounting";
import { SvgIcon } from "@/components/index";
import editPenSvg from "@/assets/images/svg/edit-pen.svg";
import { AccountingState, PaymentCard, PaymentMethods, PaymentTool, TransactionTypes } from "@/types/db/accounting";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { DiscountTypes } from "@/interfaces/store/IBooking";
import { BookingStep } from "@/constants/booking";
import { PaymentMethodTypeToPaymentTool, PaymentMethodTypes } from "@/types/db/pos-config";
import POSConfigModule from "@/store/modules/pos-config";
import { canCompleteOrder, toLocalAccountings, updateEnteredAmount } from "@/utils/vue-helpers/booking";
import Discount from "./Discount.vue";
import Promocode from "./Promocode.vue";
import IncertVoucher from "./IncertVoucher.vue";
import { formatCurrency } from "@/utils/helpers/currency";
import i18n, { getLocale } from "@/lang";
import { cloneDeep } from "lodash";
import { LogService } from "@/services/logging";
import { getDefaultPaymentTool, PaymentMethodTypeToTranslatedString } from "@/utils/vue-helpers/pos-config";
import dayjs from "dayjs";
import { BookingStatus, RefundStatus } from "@/types/db/product-slot-state";
import CashFloatModule from "@/store/modules/cash-float";
import { ref } from "vue";
import { PaymentToolMethod } from "@/types/db/accounting";
import { bookingTotalIgnoringDiscounts, createCashRoundingRefundAccounting, discountTotal, isBookingFree, restToPay } from "@/utils/vue-helpers/new-accountings";
import { hasMultiCurrenciesEnabled } from "@/utils/vue-helpers/cash-float";
import { sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import PromocodeCampaigns from "./PromocodeCampaigns.vue";
import Offers from "./Offers.vue";
import UserModule from "@/store/modules/user";
import NotificationService from "@/services/notification.service";
import AppModule from "@/store/modules/app";
import { getAccountingWithUUID, getBookingAccountings, getBookingWithUUID } from "@/api/gql/product-slot-boooking";
import { postPOSRefund } from "@/api/payment";
import Timeout from "await-timeout";
import { ACCErrors } from "@/constants/errors/accounting";
import { isBookingInDexie, syncBookingAvailabilities } from "@/utils/helpers/booking";
import { adyenPaymentMethods } from "@/constants/payment";
import { startRefundListener } from "@/services/sync-service";
export default defineComponent({
  name: "app",
  components: {
    Discount: Discount,
    SvgIcon: SvgIcon,
    Promocode: Promocode,
    PromocodeCampaigns: PromocodeCampaigns,
    IncertVoucher: IncertVoucher,
    Offers: Offers
  },
  setup: function setup() {
    var _BookingModule$select;

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var iconStyle = "filter: contrast(170%) invert(0%); padding-left: 10px;";
    var iconContent = editPenSvg;
    var iconAlt = "edit";
    var posConfig = POSConfigModule.selectedConfig;
    var paymentConfig = (posConfig === null || posConfig === void 0 ? void 0 : posConfig.paymentConfig) || {
      cash: {
        used: true,
        acceptedCurrencies: ["CHF"]
      },
      cardAuto: {
        used: false,
        processor: "ADYEN"
      },
      cardManual: {
        used: true,
        paymentMethods: ["VISA", "TWINT"]
      },
      invoice: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      toBeInvoiced: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      bankTransfer: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      cheque: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chequeVacances: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chequeCulture: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      passCulture: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chorus: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CE: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      OCCYG: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      posReka: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      buyClub: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CFF: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CGN: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      QOQA: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      DEINDEAL: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      REALDEAL: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      EXTERNAL_INCERT_VOUCHER: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      Swiss_QR_Code_Bank_Transfer: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      diverseVoucher: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      POS_BIMPLI_CADO: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      POS_KADEOS_INFINI: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      POS_ANCV_CONNECT: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      TOUT_UN_CANTON: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CHAPLINS: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      terminal: ""
    };
    var isEditOrder = ref(false);
    watchEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!BookingModule.selectedBookingUUID) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return isBookingInDexie(BookingModule.selectedBookingUUID);

            case 3:
              isEditOrder.value = _context.sent;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var cashPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cash.used;
    });
    var bookingPaymentCurrency = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currency;
    });
    var paymentCurrency = computed(function () {
      if (paymentTool.value === PaymentTool.Cash && selectedCashCurrency.value) {
        return selectedCashCurrency.value.label;
      }

      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currency;
    });
    var cardAutoPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cardAuto.used;
    });
    var cardManualPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cardManual.used;
    });
    var bankTransferPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.bankTransfer.used;
    });
    var InvoicePaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.invoice.used;
    });
    var ChequePaymentMethod = computed(function () {
      var _POSConfigModule$getP;

      return ((_POSConfigModule$getP = POSConfigModule.getPaymentConfig.cheque) === null || _POSConfigModule$getP === void 0 ? void 0 : _POSConfigModule$getP.used) && (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr");
    });
    var ChequeVacancesPaymentMethod = computed(function () {
      var _POSConfigModule$getP2;

      return ((_POSConfigModule$getP2 = POSConfigModule.getPaymentConfig.chequeVacances) === null || _POSConfigModule$getP2 === void 0 ? void 0 : _POSConfigModule$getP2.used) && (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr");
    });
    var CEPaymentMethod = computed(function () {
      var _POSConfigModule$getP3;

      return ((_POSConfigModule$getP3 = POSConfigModule.getPaymentConfig.CE) === null || _POSConfigModule$getP3 === void 0 ? void 0 : _POSConfigModule$getP3.used) && groupId.value && [19360, 16342, 16342].includes(groupId.value);
    });
    var OCCYGPaymentMethod = computed(function () {
      var _POSConfigModule$getP4;

      return ((_POSConfigModule$getP4 = POSConfigModule.getPaymentConfig.OCCYG) === null || _POSConfigModule$getP4 === void 0 ? void 0 : _POSConfigModule$getP4.used) && groupId.value && [19360, 16342, 16342].includes(groupId.value);
    });
    var isFree1 = computed(function () {
      // A booking is considered FREE if their tickets are free or is fully discounted
      return isBookingFree.value;
    });
    var isFullyPaidInPromocodeStep = computed(function () {
      // A booking that becomes fully paid in Promocode Step will have payment methods disabled
      return (BookingModule.bookingStep === BookingStep.Promocode || BookingModule.bookingStep === BookingStep.PromocodeCampaigns) && restToPay.value <= 0;
    });
    var isFullyPaidInDiscountStep = computed(function () {
      // A booking that becomes fully paid in Discount Step will have payment methods disabled
      return BookingModule.bookingStep === BookingStep.Discount && restToPay.value <= 0;
    });
    var step = computed(function () {
      return BookingModule.bookingStep;
    });
    var showDiscount = computed(function () {
      var hasDiscountRole = !UserModule.isSellerNoDiscount;
      return hasDiscountRole && (paymentConfig.cash.used || paymentConfig.cardAuto.used || paymentConfig.cardManual.used);
    });
    var groupId = computed(function () {
      return POSConfigModule.groupId;
    });
    var groupCurrencies = computed(function () {
      return POSConfigModule.groupCurrencies;
    });
    var currencies = computed(function () {
      var _CashFloatModule$cash;

      var currencies = [];
      var startAmounts = (_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.startAmounts;

      var _loop = function _loop(currency) {
        var currencyInfo = groupCurrencies.value.find(function (c) {
          return c.label === currency;
        });

        if (currencyInfo) {
          currencies.push(currencyInfo);
        }
      };

      for (var currency in startAmounts) {
        _loop(currency);
      }

      return currencies;
    }); // for multi currency payments

    var selectedCashCurrency = computed(function () {
      return BookingModule.selectedCashCurrency;
    });
    var selectedCashCurrencyLabel = computed(function () {
      var _selectedCashCurrency;

      return ((_selectedCashCurrency = selectedCashCurrency.value) === null || _selectedCashCurrency === void 0 ? void 0 : _selectedCashCurrency.label) || "";
    });
    var groupCurrency = computed(function () {
      var currency = currencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || currencies.value[0];
      return currency.label;
    }); // if there is no tracking of payments for the currently selected booking then initiate it

    if (!BookingModule.bookingsAmountsTrack[String((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.uuid)]) initiateAmountsTracking();
    var paymentSettings = computed(function () {
      // Return only payment settings that are used
      return POSConfigModule.getPaymentSettings.filter(function (setting) {
        return setting.used;
      });
    });
    var promocodeBeingChecked = computed(function () {
      return BookingModule.promocodeBeingChecked;
    });

    function selectdefaultPaymentMethod() {
      // We only support Cash with Refund, we don't force the user his default payment method in this case
      if (BookingModule.bookingStep !== BookingStep.Refund) {
        var usedPaymentTool = getDefaultPaymentTool();
        updatePaymentTool(usedPaymentTool.id, usedPaymentTool.name);
      }
    }

    function initiateAmountsTracking() {
      var _BookingModule$select2, _BookingModule$select3;

      var BookingUUID = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.uuid;
      var usedPaymentTool = POSConfigModule.getPaymentSettings.filter(function (paymentMethod) {
        return paymentMethod.used === true;
      })[0];
      var track = {
        currentAmount: 0,
        currency: ((_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.currency) || Currencies.CHF,
        // paymentTool: PaymentTool.CardAuto,
        paymentTool: usedPaymentTool.name,
        paymentToolId: usedPaymentTool.id || null,
        paymentCard: null,
        // paymentCard: PaymentCard.Mastercard,
        confirmedAmounts: []
      };
      BookingModule.addPaymentTracking({
        BookingUUID: BookingUUID,
        track: track
      });
    }

    var selectedBookingUUID = computed(function () {
      var selectedBooking = BookingModule.selectedBooking;

      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      var uuid = selectedBooking.uuid;

      if (!uuid) {
        throw new Error(PSBErrors.HasNoUUID);
      }

      return uuid;
    });
    var formattedPaymentCurrency = computed(function () {
      return formatCurrency(BookingModule.selectedBooking.currency);
    });
    var hasEnteredAmount = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currentAmount;
    });
    var isFullDiscount = computed(function () {
      if (bookingTotalIgnoringDiscounts.value <= discountTotal.value) {
        return true;
      }

      return false;
    });
    var paymentTool = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].paymentTool;
    });
    var paymentCard = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].paymentCard;
    });
    /**
     * The amount we display for the user to pay
     * For bookings that support split payment it is what is left to pay OR it is what the user enters
     * For normal bookings it is the sum of pss final values, if user enters an amount, then we show it
     */

    var displayedAmount = computed(function () {
      // if (paymentTool.value === PaymentTool.Cash) {
      //   return (
      //     formatCurrency(paymentCurrency.value) +
      //     " " +
      //     hasEnteredAmount.value.toFixed(2)
      //   );
      // }
      if (splitAmountToBePaid.value) {
        return splitAmountText.value;
      } else {
        return whatIsLeftToPayText.value;
      }
    });
    var whatIsLeftToPayText = computed(function () {
      return formatCurrency(paymentCurrency.value) + " " +
      /*Math.abs*/
      (whatIsLeftToPay.value / 100).toFixed(2);
    });
    var whatIsLeftToPay = computed(function () {
      var _selectedCashCurrency2;

      return restToPay.value * (((_selectedCashCurrency2 = selectedCashCurrency.value) === null || _selectedCashCurrency2 === void 0 ? void 0 : _selectedCashCurrency2.exchangeRate) || 1);
    });
    var splitAmountToBePaid = computed(function () {
      var _BookingModule$splitA, _selectedCashCurrency3;

      // we take the value before it was rounded (if it was), because thats what the user supplied
      return (((_BookingModule$splitA = BookingModule.splitAmount) === null || _BookingModule$splitA === void 0 ? void 0 : _BookingModule$splitA.splitAmountProvided) || 0) * (((_selectedCashCurrency3 = selectedCashCurrency.value) === null || _selectedCashCurrency3 === void 0 ? void 0 : _selectedCashCurrency3.exchangeRate) || 1);
    });
    var splitAmountText = computed(function () {
      return formatCurrency(paymentCurrency.value) + " " + splitAmountToBePaid.value.toFixed(2);
    });
    var doesSupportSplitPayment = computed(function () {
      return BookingModule.doesSupportSplitPayment;
    });
    var splitPayments = computed(function () {
      var _BookingModule$select4;

      var paidAmounts = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
        return acc.transactionType === 1 && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending && !acc.id
        /*making sure it is not coming from backend*/
        && (acc.promocode || acc.promoCodeUuid) || acc.state === AccountingState.Pending && acc.paymentMethod === PaymentMethods.METHOD_POS_CASH);
      }).flat();
      return paidAmounts;
    });
    var payInMultiCurrencies = ref(false);

    function toggleMultiCurrencies() {
      payInMultiCurrencies.value = !payInMultiCurrencies.value;

      if (!payInMultiCurrencies.value) {
        BookingModule.setSelectedCashCurrency(null);
        updateEnteredAmount(Math.abs(restToPay.value) / 100);
      } else {
        var currency = currencies.value.filter(function (c) {
          return c.label !== bookingPaymentCurrency.value;
        })[0];
        BookingModule.setSelectedCashCurrency(currency);
        updateEnteredAmount(Math.abs(restToPay.value) * currency.exchangeRate / 100);
      }
    }

    function selectedCashCurrencyChanged(currencyLabel) {
      var currency = currencies.value.find(function (c) {
        return c.label === currencyLabel;
      }) || null;
      BookingModule.setSelectedCashCurrency(currency);
      updateEnteredAmount(Math.abs(restToPay.value) * ((currency === null || currency === void 0 ? void 0 : currency.exchangeRate) || 1) / 100);
    }

    function updatePaymentCurrency(currency) {
      BookingModule.setPaymentCurrency({
        BookingUUID: BookingModule.selectedBookingUUID,
        currency: currency
      });
    }

    function updatePaymentTool(paymentToolId, paymentTool) {
      BookingModule.setPaymentTool({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentTool: paymentTool,
        paymentToolId: paymentToolId
      }); // isDiscountsDisplayed.value = false;

      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Payment
      });
    }

    function updatePaymentCard(paymentCard) {
      BookingModule.setPaymentCard({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentCard: paymentCard
      });
    }

    function showCalculator() {
      ModalModule.setStatus(ModalStatus.PaymentCalculator);
    }

    function disablePaymentTool(paymentOption) {
      // A payment too is disabled when:
      // It is not selected && Booking has confirmedAmounts && Discount is not selected
      // return (
      //   paymentTool.value !== paymentOption &&
      //   BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID]
      //     .confirmedAmounts.length > 0 &&
      //   paymentTool.value !== PaymentTool.Discount
      // );
      // @Hamza: I am disabling only when discount is selected
      // Please check if this is ok cause now with split payment, there is
      // no reason to disable payment methods.
      if (paymentOption === PaymentTool.Discount) {
        return BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID].confirmedAmounts.length > 0;
      }

      return false;
    }

    function displayDiscounts() {
      // First if there is no discount tracking for this booking lets add a discount tracking to this booking with default values
      var d = BookingModule.selectedBookingDiscountTrack;

      if (d) {
        BookingModule.setBookingStep({
          bookingUUID: BookingModule.selectedBookingUUID,
          step: BookingStep.Discount
        });
        return;
      }

      var selectedBooking = BookingModule.selectedBooking;

      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      BookingModule.addDiscountTracking({
        BookingUUID: BookingModule.selectedBookingUUID,
        track: {
          isApplied: false,
          type: DiscountTypes.Percentage_Discount,
          value: 5,
          isOnAllOrder: true,
          pricesIds: _toConsumableArray(new Set(selectedBooking.pssList.map(function (pss) {
            return pss.priceId;
          }))),
          pssDiscounts: [],
          discountTotalValue: 0
        }
      });
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Discount
      });
    }

    function displayPromocodeArea() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Promocode
      });
    }

    function displayPromocodeCampaigns() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.PromocodeCampaigns
      });
    }

    function displayOffers() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Offers
      });
    }

    var selectedBooking = computed(function () {
      var booking = BookingModule.selectedBooking;

      if (!booking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      return booking;
    });

    function applyCashPayment() {
      deleteUncompletedBookingAccountings(selectedBooking.value);
      applyPayment();
    }

    var refundPaymentMethodOptions = computed(function () {
      // Return used payment methods
      var refundPaymentMethods = _toConsumableArray(paymentSettings.value); // If there is no payment method left, then we return cash


      if (!refundPaymentMethods.length) {
        refundPaymentMethods.push({
          id: PaymentMethodTypes.Cash,
          name: PaymentMethodTypeToTranslatedString.value[PaymentMethodTypes.Cash]
        });
      } else {
        var cardIndex = refundPaymentMethods.findIndex(function (pm) {
          return pm.id === PaymentMethodTypes.CardAuto;
        });

        if (cardIndex > -1) {
          // Push the Card method to bottom of the list if its disabled
          var element = refundPaymentMethods.splice(cardIndex, 1)[0];
          refundPaymentMethods.push(element);
        }
      } // Note that INCERT Voucher now is a payment method
      // The refund of this paymentMethod is done automatically when cancelling the confirmed ticket like below:
      // cancel ticket --> create cancellation accounting & refund accounting --> user confirms booking --> POS communicate to external voucher to refund and then confirm refund accounting
      // So we actually do not need INCERT Voucher as a refund payment method to be shown in the dropdown, lets remove it if it is there


      var incertVoucherMethodIndex = refundPaymentMethods.findIndex(function (p) {
        return p.id === PaymentMethods.EXTERNAL_INCERT_VOUCHER;
      });

      if (incertVoucherMethodIndex > -1) {
        refundPaymentMethods = refundPaymentMethods.filter(function (p) {
          return p.id !== PaymentMethods.EXTERNAL_INCERT_VOUCHER;
        });
      }

      return refundPaymentMethods;
    }); // let's set the default payment method also for refund

    var refundPaymentMethod = ref(refundPaymentMethodOptions.value[0].id || PaymentMethodTypes.Cash);
    var pssToRefundList = computed(function () {
      var bookingCopy = cloneDeep(selectedBooking.value); // get the pss we're about to refund

      var cancelledPss = bookingCopy.pssList.filter(function (pss) {
        return pss.bookingStatus === BookingStatus.Canceled;
      });

      if (!cancelledPss || !cancelledPss.length) {
        return [];
      } // Find the ones we need to refund, they are the one that have positive balance


      var cancelledPssUuidString = cancelledPss.map(function (pss) {
        return pss.uuid;
      }).join(" - ");
      var pssToRefundList = BookingModule.pssListBalances.filter(function (pss) {
        return cancelledPssUuidString.includes(String(pss.pssUuid)) && pss.balance > 0;
      }).map(function (pss) {
        return pss.pss;
      });
      return pssToRefundList;
    });

    function proceedAdyenRefund(_x) {
      return _proceedAdyenRefund.apply(this, arguments);
    }
    /**
     * Create Refund accountings for the cancelled PSS with the parameter amount
     * amountInCents is negative
     */


    function _proceedAdyenRefund() {
      _proceedAdyenRefund = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(amountInCents) {
        var bookingCopy, alreadyRefunded, accountingToRefund, _loop3, i, _ret, bookingId, accountingToRefundId, uid, accountingUuid, bookingInfo, accountingInfo, retries, refundableAmountValues, refundableAmount, amount, refundData, _refundResponse$data, _refundResponse$data2, _refundResponse$data3, refundResponse, pulledAccountings, remoteAccountings, newAdyenAccounting, newAccountings, message, keyword, parts;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                alreadyRefunded = function _alreadyRefunded(splitReference) {
                  var refundAndPaymentAccountings = bookingCopy.accountings.filter(function (acc) {
                    return adyenPaymentMethods.includes(acc.paymentMethod) && (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND || acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT) && acc.state === AccountingState.Completed && acc.splitReference === splitReference;
                  }).map(function (ac) {
                    return ac.accountingEntriesList;
                  }).flat().map(function (ae) {
                    return ae.value;
                  });
                  var refundAndPaymentSum = sumArray(refundAndPaymentAccountings);
                  return refundAndPaymentSum <= 0;
                };

                bookingCopy = cloneDeep(selectedBooking.value); // checks if an accounting is already refunded by calculating the differnce between payments and refunds

                _loop3 = function _loop3(i) {
                  var pssToRefund = pssToRefundList.value[i];
                  accountingToRefund = bookingCopy.accountings.find(function (acc) {
                    return adyenPaymentMethods.includes(acc.paymentMethod) && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT && acc.splitReference && acc.state === AccountingState.Completed && !alreadyRefunded(acc.splitReference) && acc.accountingEntriesList.some(function (ae) {
                      return ae.productSlotStateUuid === pssToRefund.uuid;
                    });
                  });

                  if (accountingToRefund) {
                    // one accounting at a time
                    return "break";
                  }
                };

                i = 0;

              case 4:
                if (!(i < pssToRefundList.value.length)) {
                  _context2.next = 11;
                  break;
                }

                _ret = _loop3(i);

                if (!(_ret === "break")) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("break", 11);

              case 8:
                i++;
                _context2.next = 4;
                break;

              case 11:
                if (accountingToRefund) {
                  _context2.next = 14;
                  break;
                }

                LogService.info("No adyen payment accounting to refund was found");
                return _context2.abrupt("return");

              case 14:
                bookingId = bookingCopy.id;
                accountingToRefundId = accountingToRefund.id;

                if (!(!bookingId || !accountingToRefundId)) {
                  _context2.next = 54;
                  break;
                }

                _context2.prev = 17;
                AppModule.updatedIsLoading(true);
                uid = bookingCopy.uuid;
                accountingUuid = accountingToRefund.uuid;

                if (uid) {
                  _context2.next = 23;
                  break;
                }

                throw new Error(PSBErrors.HasNoUUID);

              case 23:
                if (accountingUuid) {
                  _context2.next = 25;
                  break;
                }

                throw new Error(ACCErrors.HasNoUUID);

              case 25:
                retries = 0;

              case 26:
                if (!((!bookingInfo || !accountingInfo) && retries < 5)) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 29;
                return getBookingWithUUID(uid);

              case 29:
                bookingInfo = _context2.sent;
                _context2.next = 32;
                return getAccountingWithUUID(accountingUuid);

              case 32:
                accountingInfo = _context2.sent;
                LogService.info("Booking with uuid: ".concat(uid, " or accounting with uuid: ").concat(accountingUuid, " were not found when refunding by card, retrying in 3000ms"));
                retries++;
                _context2.next = 37;
                return Timeout.set(3000);

              case 37:
                _context2.next = 26;
                break;

              case 39:
                if (!(!bookingInfo || !accountingInfo)) {
                  _context2.next = 43;
                  break;
                }

                // synching failed
                LogService.info("Booking with uuid: ".concat(uid, " or accounting with uuid: ").concat(accountingUuid, " were not found when refunding by card, stopped retrying"));
                NotificationService.showGeneralResponseError();
                return _context2.abrupt("return");

              case 43:
                bookingId = bookingInfo.id || undefined;
                accountingToRefundId = accountingInfo.id || undefined;
                _context2.next = 51;
                break;

              case 47:
                _context2.prev = 47;
                _context2.t0 = _context2["catch"](17);
                LogService.info("Error occured when fetching booking/accounting info: ".concat(selectedBooking.value.uuid), {
                  error: _context2.t0
                });
                NotificationService.showGeneralResponseError();

              case 51:
                _context2.prev = 51;
                AppModule.updatedIsLoading(false);
                return _context2.finish(51);

              case 54:
                refundableAmountValues = accountingToRefund.accountingEntriesList.filter(function (ae) {
                  return pssToRefundList.value.map(function (pss) {
                    return pss.uuid;
                  }).includes(ae.productSlotStateUuid);
                }).flatMap(function (ae) {
                  return ae.value;
                });
                refundableAmount = sumArray(refundableAmountValues) * -1; // we use the smallest amount between the actual accounting value to avoid over-refunding in case of split payments/refunds
                // using Math.max because both values are negative

                amount = Math.max(amountInCents, refundableAmount);
                refundData = {
                  bookingId: bookingId,
                  amount: amount / 100 * -1,
                  paymentMethod: accountingToRefund.paymentMethod,
                  accounting: accountingToRefundId,
                  channel: "SMEETZ POS"
                };
                LogService.info("starting refund with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100, ", payload attached"), {
                  refundData: refundData
                });
                AppModule.updatedIsLoading(true);
                _context2.prev = 60;
                _context2.next = 63;
                return postPOSRefund(refundData);

              case 63:
                refundResponse = _context2.sent;

                if (!(!((_refundResponse$data = refundResponse.data) !== null && _refundResponse$data !== void 0 && _refundResponse$data.productSlotStates) || !((_refundResponse$data2 = refundResponse.data) !== null && _refundResponse$data2 !== void 0 && (_refundResponse$data3 = _refundResponse$data2.bookingRecap) !== null && _refundResponse$data3 !== void 0 && _refundResponse$data3.accounting))) {
                  _context2.next = 67;
                  break;
                }

                LogService.info("Unexpected response received when refunding with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100), {
                  refundData: refundData,
                  response: refundResponse
                });
                throw new Error("Unexpected adyen refund response");

              case 67:
                LogService.info("Accounting successfully refunded with adyen with amount ".concat(amountInCents / 100, ", going to update booking"), {
                  refundData: refundData,
                  response: refundResponse
                }); // get the newly created accountings from backend

                _context2.next = 70;
                return getBookingAccountings(String(bookingId));

              case 70:
                pulledAccountings = _context2.sent;

                if (pulledAccountings) {
                  _context2.next = 75;
                  break;
                }

                LogService.info("No accountings were pulled from backend for booking with uuid: ".concat(bookingCopy.uuid));
                NotificationService.showGeneralResponseError();
                return _context2.abrupt("return");

              case 75:
                remoteAccountings = toLocalAccountings(bookingCopy.uuid, pulledAccountings); // get refund accounting created by backend

                newAdyenAccounting = remoteAccountings.find(function (remoteAcc) {
                  return adyenPaymentMethods.includes(remoteAcc.paymentMethod) && remoteAcc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND && !bookingCopy.accountings.some(function (localAcc) {
                    return localAcc.uuid === remoteAcc.uuid;
                  });
                });

                if (newAdyenAccounting) {
                  _context2.next = 79;
                  break;
                }

                throw new Error("No adyen accounting was created by backend");

              case 79:
                // add the new refund accounting and update the current booking
                newAccountings = bookingCopy.accountings.concat(newAdyenAccounting);
                BookingModule.updateBookingAccountings({
                  bookingUUID: bookingCopy.uuid || "",
                  accountings: newAccountings
                });

                if (newAdyenAccounting.state === AccountingState.Failed) {
                  message = newAdyenAccounting.message;
                  keyword = "FAILED_REFUND >>";
                  parts = (message === null || message === void 0 ? void 0 : message.split(keyword)) || []; // Check if the keyword exists and there is content after it

                  if (parts.length > 1) {
                    NotificationService.showCustomMessage(parts[1].trim(), "warning");
                  } else {
                    // Default message if the keyword is not present
                    NotificationService.showCustomMessage(String(t("payment-service.unknown")), "warning");
                  }
                } else if (newAdyenAccounting.state === AccountingState.Started) {
                  NotificationService.showCustomInfoWithTitle(t("adyen-refund.in-progress-message"), t("adyen-refund.in-progress"));

                  if (bookingCopy.uuid && newAdyenAccounting.uuid) {
                    startRefundListener(bookingCopy.uuid, newAdyenAccounting.uuid);
                  }
                }

                _context2.next = 88;
                break;

              case 84:
                _context2.prev = 84;
                _context2.t1 = _context2["catch"](60);
                LogService.info("Error occured when refunding with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100), {
                  refundData: refundData,
                  error: _context2.t1
                });
                NotificationService.showGeneralResponseError();

              case 88:
                _context2.prev = 88;
                AppModule.updatedIsLoading(false);
                return _context2.finish(88);

              case 91:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[17, 47, 51, 54], [60, 84, 88, 91]]);
      }));
      return _proceedAdyenRefund.apply(this, arguments);
    }

    function proceedRegularRefund(amountInCents) {
      var bookingCopy = cloneDeep(selectedBooking.value);
      var refundPaymentTool = PaymentMethodTypeToPaymentTool[refundPaymentMethod.value]; // create TICKET accounting

      var _createRefundPSSAccou = createRefundPSSAccounting(amountInCents, PaymentToolMethod[refundPaymentTool]),
          refundAccountings = _createRefundPSSAccou.refundAccountings,
          roundingDifference = _createRefundPSSAccou.roundingDifference,
          refundedPss = _createRefundPSSAccou.refundedPss;

      refundAccountings.forEach(function (acc) {
        return bookingCopy.accountings.push(acc);
      });

      if (roundingDifference && PaymentToolMethod[refundPaymentTool] === PaymentMethods.METHOD_POS_CASH) {
        var roundingAccounting = createCashRoundingRefundAccounting(bookingCopy, roundingDifference, refundedPss);
        bookingCopy.accountings.push(roundingAccounting);
      } // lests add refund info to the pss


      var pssUuidsList = refundAccountings.map(function (acc) {
        return acc.accountingEntriesList;
      }).flat().map(function (ae) {
        return ae.productSlotStateUuid;
      });
      var refundedPssList = bookingCopy.pssList.filter(function (pss) {
        return pssUuidsList.includes(pss.uuid);
      });

      for (var i = 0; i < refundedPssList.length; i++) {
        refundedPssList[i].refundedAt = dayjs().toISOString();
        refundedPssList[i].refundAmount = getPSSValue(refundedPssList[i]); // because we fully refund a pss

        refundedPssList[i].refundStatus = RefundStatus.Completed;
      } //update cashfloat: extract refund amount from total cashfloat
      // const previousCashFloatAmount = CashFloatModule.cashFloat?.amount || 0;
      // const dateNow = dayjs().toISOString();
      // const updatedAmount = previousCashFloatAmount - Math.abs(amountInCents);
      // //update amount field of Cash float in db and state
      // CashFloatModule.setCashFloat(
      //   Object.assign({}, CashFloatModule.cashFloat, {
      //     updatedAt: dateNow,
      //     amount: updatedAmount,
      //   })
      // );


      BookingModule.updateBooking(bookingCopy);
    }
    /**
     * Call appropriate refund function depending on payment method
     * amountInCents is negative
     */


    function handleRefund(_x2) {
      return _handleRefund.apply(this, arguments);
    }

    function _handleRefund() {
      _handleRefund = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(amountInCents) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (selectedBooking.value.uuid) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (!BookingModule.refundListeners[selectedBooking.value.uuid]) {
                  _context3.next = 6;
                  break;
                }

                LogService.info("Booking already has a refund in progress, aborting");
                NotificationService.showCustomMessageWithTitle(i18n.global.t("adyen-refund.already-in-progress-message"), i18n.global.t("adyen-refund.in-progress"), "warning");
                return _context3.abrupt("return");

              case 6:
                LogService.info("Proceeding refund for booking: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100, " paymentMethod: ").concat(refundPaymentMethod.value), {
                  params: {
                    booking: selectedBooking.value
                  }
                });
                _context3.t0 = refundPaymentMethod.value;
                _context3.next = _context3.t0 === PaymentMethodTypes.CardAuto ? 10 : 12;
                break;

              case 10:
                proceedAdyenRefund(amountInCents);
                return _context3.abrupt("break", 14);

              case 12:
                proceedRegularRefund(amountInCents);
                return _context3.abrupt("break", 14);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _handleRefund.apply(this, arguments);
    }

    var isPromocodeApplied = computed(function () {
      return BookingModule.isPromocodeApplied;
    });
    var showDiscountButton = computed(function () {
      // Hide discount button for Chillon (L2-1009)
      if (POSConfigModule.groupId === 16268) {
        return false;
      }

      return true;
    });
    var refundAmount = computed(function () {
      /**
       * If refund payment is card, return only refundable adyen payments amount
       * Otherwise, return the full amount to refund
       */
      return refundPaymentMethod.value === PaymentMethodTypes.CardAuto ? cardRefundAmount.value : restToPay.value;
    });
    var cardRefundAmount = computed(function () {
      var amountToRefund = 0;
      var accountings = selectedBooking.value.accountings;

      var isValidAdyenPayment = function isValidAdyenPayment(acc, uuid) {
        var isRefund = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return adyenPaymentMethods.includes(acc.paymentMethod) && (isRefund ? acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND : acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT) && acc.state === AccountingState.Completed && (isRefund ? acc.refundPspReference : acc.pspReference) && acc.accountingEntriesList.some(function (ae) {
          return ae.productSlotStateUuid === uuid;
        });
      };

      var _iterator = _createForOfIteratorHelper(pssToRefundList.value),
          _step;

      try {
        var _loop2 = function _loop2() {
          var pssToRefund = _step.value;
          var uuid = pssToRefund.uuid;
          var paymentAmounts = accountings.filter(function (acc) {
            return isValidAdyenPayment(acc, uuid);
          }).flatMap(function (acc) {
            return acc.accountingEntriesList.filter(function (ae) {
              return ae.productSlotStateUuid === uuid;
            }).map(function (ae) {
              return ae.value;
            });
          });
          var refundAmounts = accountings.filter(function (acc) {
            return isValidAdyenPayment(acc, uuid, true);
          }).flatMap(function (acc) {
            return acc.accountingEntriesList.filter(function (ae) {
              return ae.productSlotStateUuid === uuid;
            }).map(function (ae) {
              return ae.value;
            });
          });
          amountToRefund += sumArray(paymentAmounts) + sumArray(refundAmounts); // sum because refundAmounts are negative
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return Math.min(amountToRefund * -1, 0);
    });
    var refundAmountText = computed(function () {
      return formatCurrency(paymentCurrency.value) + " " + (refundAmount.value / 100).toFixed(2);
    });

    function isRefundPaymentMethodDisabled(paymentSetting) {
      var _POSConfigModule$sele;

      if (paymentSetting.id === PaymentMethodTypes.CardAuto && (!((_POSConfigModule$sele = POSConfigModule.selectedConfig) !== null && _POSConfigModule$sele !== void 0 && _POSConfigModule$sele.isRefundActivated) || cardRefundAmount.value * -1 <= 0 || cardRefundAmount.value !== restToPay.value)) {
        /**
         * Card refunds are disabled in case:
         * 1- It is disabled from BO
         * 2- There's no refundable card amount
         * 3- Card refund amount !== the total refund amount, meaning in case of split payments (cash & card), until it is requested by the client.
         */
        return true;
      }

      return false;
    } // Whenever the user resets paymentSettings we need to select a default paymentMethod


    watch(paymentSettings, function () {
      selectdefaultPaymentMethod();
    }, {
      deep: true
    });
    watch([step, paymentTool], function () {
      if (!payInMultiCurrencies.value) {
        return;
      }

      if (BookingModule.selectedBookingPaymentMethodId !== PaymentMethodTypes.Cash || step.value !== BookingStep.Payment) {
        // toggle off multi currency if not using cash or not in payment step
        toggleMultiCurrencies();
      }
    });
    return {
      t: t,
      paymentTool: paymentTool,
      paymentCard: paymentCard,
      hasEnteredAmount: hasEnteredAmount,
      isFullDiscount: isFullDiscount,
      whatIsLeftToPay: whatIsLeftToPay,
      displayedAmount: displayedAmount,
      // total,
      formattedPaymentCurrency: formattedPaymentCurrency,
      // bookingTotal,
      PaymentTool: PaymentTool,
      PaymentCard: PaymentCard,
      showDiscount: showDiscount,
      paymentCurrency: paymentCurrency,
      // showCashButton,
      step: step,
      BookingStep: BookingStep,
      updatePaymentCurrency: updatePaymentCurrency,
      updateEnteredAmount: updateEnteredAmount,
      updatePaymentTool: updatePaymentTool,
      updatePaymentCard: updatePaymentCard,
      applyCashPayment: applyCashPayment,
      showCalculator: showCalculator,
      disablePaymentTool: disablePaymentTool,
      Currencies: Currencies,
      paymentConfig: paymentConfig,
      displayDiscounts: displayDiscounts,
      displayPromocodeArea: displayPromocodeArea,
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle,
      cashPaymentMethod: cashPaymentMethod,
      cardAutoPaymentMethod: cardAutoPaymentMethod,
      cardManualPaymentMethod: cardManualPaymentMethod,
      bankTransferPaymentMethod: bankTransferPaymentMethod,
      InvoicePaymentMethod: InvoicePaymentMethod,
      isFree1: isFree1,
      isFullyPaidInPromocodeStep: isFullyPaidInPromocodeStep,
      isFullyPaidInDiscountStep: isFullyPaidInDiscountStep,
      canCompleteOrder: canCompleteOrder,
      selectedBooking: selectedBooking,
      groupId: groupId,
      getLocale: getLocale,
      doesSupportSplitPayment: doesSupportSplitPayment,
      whatIsLeftToPayText: whatIsLeftToPayText,
      isEditOrder: isEditOrder,
      ChequePaymentMethod: ChequePaymentMethod,
      ChequeVacancesPaymentMethod: ChequeVacancesPaymentMethod,
      handleRefund: handleRefund,
      paymentSettings: paymentSettings,
      PaymentMethodTypeToPaymentTool: PaymentMethodTypeToPaymentTool,
      PaymentMethodTypeToTranslatedString: PaymentMethodTypeToTranslatedString,
      CEPaymentMethod: CEPaymentMethod,
      OCCYGPaymentMethod: OCCYGPaymentMethod,
      selectdefaultPaymentMethod: selectdefaultPaymentMethod,
      refundPaymentMethod: refundPaymentMethod,
      refundPaymentMethodOptions: refundPaymentMethodOptions,
      PaymentMethodTypes: PaymentMethodTypes,
      isPromocodeApplied: isPromocodeApplied,
      currencies: currencies,
      selectedCashCurrency: selectedCashCurrency,
      groupCurrency: groupCurrency,
      selectedCashCurrencyChanged: selectedCashCurrencyChanged,
      selectedCashCurrencyLabel: selectedCashCurrencyLabel,
      toggleMultiCurrencies: toggleMultiCurrencies,
      payInMultiCurrencies: payInMultiCurrencies,
      bookingPaymentCurrency: bookingPaymentCurrency,
      restToPay: restToPay,
      hasMultiCurrenciesEnabled: hasMultiCurrenciesEnabled,
      showDiscountButton: showDiscountButton,
      displayPromocodeCampaigns: displayPromocodeCampaigns,
      displayOffers: displayOffers,
      isRefundPaymentMethodDisabled: isRefundPaymentMethodDisabled,
      refundAmount: refundAmount,
      refundAmountText: refundAmountText,
      promocodeBeingChecked: promocodeBeingChecked
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return syncBookingAvailabilities(_this.selectedBooking);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var leftToPay;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this2.selectdefaultPaymentMethod();

              window.SingleCategoryEvent = SingleCategoryEvent;
              leftToPay = restToPay.value;
              updateEnteredAmount(Math.abs(leftToPay) / 100);

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  beforeUnmount: function beforeUnmount() {
    BookingModule.setSelectedCashCurrency(null);
    updateEnteredAmount(0);
  }
});